module.exports = __webpack_public_path__ + "img/RC.30e41cd2.png";